module.exports = __webpack_public_path__ + "img/designer.2a01dc3b.jpg";